import { IOProps } from 'react-compose-io'
import { Grid, IconButton } from '@material-ui/core'
import { customTheme } from '../../styles/customTheme'
import { SelecionarParceiro } from '../SelecionarParceiro'
import { Tipografia } from '../Tipografia'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { SelecaoParceiroExecucaoCicloIO } from './SelecaoParceiroExecucaoCiclo.IO'
import { ValidacaoExecucaoCiclo } from '../ValidacaoExecucaoCiclo'

export type SelecaoParceiroExecucaoCicloProps = {
  subtitulo: string
  voltarPage: string
  pageValidarExecucao: (parceiroId: number) => string
}

export function SelecaoParceiroExecucaoCicloView({ _io, subtitulo }: IOProps<SelecaoParceiroExecucaoCicloIO, SelecaoParceiroExecucaoCicloProps>) {
  const { Container, Avatar, CabecalhoContainer } = _io.styles

  return (
    <>
      {_io.parceiroSelecionado == 0 ? (
        <SelecionarParceiro handleConfirmar={_io.handleConfirmar} parceiros={_io.parceiros} subtitulo={subtitulo} />
      ) : (
        <Container>
          <Grid container alignItems="center" justifyContent="space-between" spacing={2}>
            <Grid item>
              <CabecalhoContainer>
                <IconButton onClick={_io.handleIconeVoltar}>
                  <ArrowBackIcon color="disabled" />
                </IconButton>
                <Avatar src={_io.parceiroLogo} />
                <Tipografia variant="h6" fontWeight="500" colorText={customTheme.colors.grey23}>
                  {_io.parceiroNome}
                </Tipografia>
              </CabecalhoContainer>
            </Grid>
          </Grid>
          <ValidacaoExecucaoCiclo parceiroId={_io.parceiroSelecionado} />
        </Container>
      )}
    </>
  )
}
